<template>
  <div class="modal-overlay" @pointerdown="handleMouseDown" @pointerup="handleMouseUp">
    <div class="single-modal-container" @click.stop="" style="width: 90%; height: 95%;" ref="modal">
      <div class="modal-body-edit-box-title">
        <h2>{{ $t('show_path') }}</h2>
        <img src="@/assets/images/x_black.svg" @click.stop="isPathModalOpen = false"/>
      </div>
      <div class="modal-body-edit-box-content" style="height: calc(100% - 56px);" :style="getIsMobile() ? {} : { flexDirection: 'row' }">
        <div class="modal-body-right" @click.stop="" style="gap: 10px; height: 100%; width: 100%;">
          <div class="modal-body-edit-box" style="height: fit-content; gap: 10px; padding: 0; border: none;" :style="getIsMobile() ? {} : { flexDirection: 'row' }">
            <div :style="getIsMobile() ? {} : { width: '33.33%' }">
              <h3 v-show="!getIsMobile()">{{ $t('device') }}</h3>
              <select v-model="selectedDevice">
                <option v-for="device in device_list" :key="device.device_id" :value="device.device_id">{{ device.device_name }}</option>
              </select>
            </div>
            <div :style="getIsMobile() ? {} : { width: '33.33%' }">
              <h3 v-show="!getIsMobile()">{{ $t('start_date') }}</h3>
              <input type="datetime-local" v-model="startDate" @change="onDateTimeSelected" />
            </div>
            <div :style="getIsMobile() ? {} : { width: '33.33%' }">
              <h3 v-show="!getIsMobile()">{{ $t('end_date') }}</h3>
              <input type="datetime-local" v-model="endDate" @change="onDateTimeSelected" />
            </div>
          </div>
          <div id="pathMap" style="width: 100%; height: 100%;">
            <div class="map-button-gruop">
              <button @click="pathMap.zoomIn()" :disabled="pathMap && nowZoomLevel === pathMap.getMaxZoom()"><img src="../assets/images/plus.svg" /></button>
              <button @click="pathMap.zoomOut()" :disabled="pathMap && nowZoomLevel === pathMap.getMinZoom()"><img src="../assets/images/minuse.svg" /></button>
            </div>
          </div>
        </div>
        <!-- 우측: 경로 리스트 -->
        <div class="modal-body-left" @click.stop="" :style="getIsMobile() ? { height: '300px' } : {}">
          <div class="modal-body-card-box">
            <div style="display: flex; width: 100%; justify-content: space-between;
                        padding: 10px;
                        align-items: center;">
              <div class="button-group" style="width: 170px;">
                <button @click.stop="isStartedReplay ? stopReplay() : startReplay()" :disabled="isCanNotReplay" :class="isStartedReplay ? 'delete-button' : 'action-button'" style="width: 110px;">
                  {{ isStartedReplay ? $t('stop_replay') : $t('start_replay') }}
                </button>
              </div>
              <select id="speed-select" v-model="selectedSpeed" style="width: 80px;">
                <option value=0>ALL</option>
                <option value=0.1>0.1s</option>
                <option value=0.5>0.5s</option>
                <option value=1>1s</option>
              </select>
            </div>
            <div ref="cardContainer" style="display: flex; flex-direction: column; width: 100%; height: calc(100% - 60px); padding: 10px; gap: 5px; overflow-y: auto; align-items: center;">
              <div class="path-timeline-box" v-for="(marker, index) in paginatedData"
                :key="marker.options.timestamp"
                @click.stop="showSelectedMarker(marker, index)"
                :class="{ selected: selectedRow && (selectedRow % itemsPerPage === index) && (parseInt(selectedRow / itemsPerPage) + 1) === currentPage}"
                ref="markerCards"
                style="cursor: pointer;">
                <header class="path-timeline-header">
                  <div class="path-timeline-header-left">
                    <h3 :style="marker.options.resend === 1 ? { color: '#ccc' } : {}">{{ ConvertDateTimeString(new Date(marker.options.timestamp), "YYYY-MM-DD HH:MM:SS") }}</h3>
                  </div>
                  <div class="path-timeline-header-right">
                    <img :src="batteryImage(marker.options.batteryLevel)" />
                    <h3 :style="marker.options.resend === 1 ? { color: '#ccc' } : {}">{{ marker.options.batteryLevel }} %</h3>
                  </div>
                </header>
              </div>
            </div>
            <!-- 페이지네이션 -->
            <div class="pagination-control">
              <div>
                <img src="@/assets/images/double_arrow_left_gray.svg" @click.stop="prevPagePer" v-show="currentPage !== 1"/>
                <img src="@/assets/images/arrow_left_gray.svg" @click.stop="prevPage" v-show="currentPage !== 1"/>
              </div>
              <span v-for="page in currentPageRange" :key="page" @click.stop="currentPage = page" :class="{ selected: currentPage === page }" :style="currentPage === page ? {cursor: 'default'} : {}">{{ page }}</span>
              <div>
                <img src="@/assets/images/arrow_right_gray.svg" @click.stop="nextPage" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
                  <img src="@/assets/images/double_arrow_right_gray.svg" @click.stop="nextPagePer" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import { ref, onMounted, onUnmounted, watch, nextTick, computed } from 'vue';
import L from 'leaflet';
import { device_list, GET_SERVER_REQUEST } from '../utils/ServerConnect';
import { firstMapSetting, drawMarkerGradient, defaultLocation, defaultZoomLevel } from '../utils/MapSetting';
import { ConvertDateTimeString, getIsMobile } from '../utils/GlobalUtility'
import { loadingStore } from '@/utils/LoadingStore';
import { showNotification } from '@/utils/Notification';
import { selectedSingleDevice } from '@/utils/SearchDevice';
import { isPathModalOpen } from '@/utils/ModalUtility';

const modal = ref(null);
let isDragging = false;

const pathMap = ref(null);
let markerGroup = L.layerGroup();
const allMarkers = ref([]);

const selectedRow = ref(null); // 선택된 마커의 해당하는 행을 추적하기 위함
const cardContainer = ref(null);
const markerCards = ref([]);

const latlngList = ref([]);
const nowZoomLevel = ref(17);

// 시작날자와 끝날자 관리
const startDate = ref('');
const endDate = ref('');

const isCanNotReplay = ref(false);
const selectedSpeed = ref(0);
const isStartedReplay = ref(false);
// const isSearched = ref(false);

const selectedDevice = ref(null);

watch([selectedDevice], async () => {
  loadingStore.showLoading();
  clearDeviceLayers();
  await searchDevicePath();
  loadingStore.hideLoading();
});
const onDateTimeSelected = async () => {
  loadingStore.showLoading();
  clearDeviceLayers();
  await searchDevicePath();
  loadingStore.hideLoading();
};
watch([selectedSpeed], (newValue, oldValue) => {
  if (newValue === oldValue) return;
  if (newValue[0] !== '0') {
    isCanNotReplay.value = false;
    if (currentIndex !== 0) {
      clearInterval(replayInterval);
      startReplay();
    }
  } else {
    clearDeviceLayers();
    allMarkers.value.forEach(marker => markerGroup.addLayer(marker)); // 재생속도가 0(ALL)일 경우 바로 표시해주고 나감
    isCanNotReplay.value = true;
    isStartedReplay.value = false;
  }
});

onMounted(async () => {
  pathMap.value = await firstMapSetting('pathMap', 17); // 지도 생성
  pathMap.value.addLayer(markerGroup);
  pathMap.value.on("zoomend", () => {
    nowZoomLevel.value = pathMap.value.getZoom();
  });

  device_list.value = await GET_SERVER_REQUEST('device');

  if (selectedSingleDevice.value) selectedDevice.value = selectedSingleDevice.value.device_id;
  else selectedDevice.value = device_list.value[0].device_id;
});

onUnmounted(() => {
  loadingStore.showLoading();
  clearDeviceLayers();
  clearInterval(replayInterval);
  loadingStore.hideLoading();
});

const clearDeviceLayers = () => {
  isCanNotReplay.value = true;
  // 지도에 있는 마커 전부 삭제
  markerGroup.clearLayers();
  allMarkers.value = [];

  selectedRow.value = null;
  currentIndex = 0;
};

// 좌표 조회
const searchDevicePath = async () => {
  let datetimeRange;
  if (!startDate.value || !endDate.value) {
    const nowDateTime = new Date();
    const oneHourBefore = new Date(nowDateTime);
    oneHourBefore.setHours(nowDateTime.getHours() - 1);
    nowDateTime.setSeconds(nowDateTime.getSeconds() + 1);

    datetimeRange = '?starttime=' + ConvertDateTimeString(oneHourBefore, 'YYYYMMDDHHMM')
                    + '&endtime=' + ConvertDateTimeString(nowDateTime, 'YYYYMMDDHHMM');

    startDate.value = ConvertDateTimeString(oneHourBefore, 'YYYY-MM-DDTHH:MM');
    endDate.value = ConvertDateTimeString(nowDateTime, 'YYYY-MM-DDTHH:MM');
  } else {
    datetimeRange = '?starttime=' + ConvertDateTimeString(startDate.value)
                    + '&endtime=' + ConvertDateTimeString(endDate.value);
  }

  await GET_SERVER_REQUEST("location", '/' + selectedDevice.value + datetimeRange)
  .then(data => {
    updateMarkers(data);
    selectedSpeed.value === 0 ? isCanNotReplay.value = true : isCanNotReplay.value = false;
  });

  if (allMarkers.value.length > 0) {
    const bounds = allMarkers.value.map(m => {
      const { lat, lng } = m.getLatLng();
      return [lat, lng];
    });
    pathMap.value.fitBounds(bounds);
  } else {
    pathMap.value.setView(defaultLocation.value, defaultZoomLevel.value)
  }

  showNotification('조회 완료', 'alarm', 'top-center');
};

// 마커 업데이트
const updateMarkers = (data) => {
  if (!pathMap.value || !data) return;

  // 기존 마커 제거
  markerGroup.clearLayers();
  latlngList.value = [];

  const newMarkers = [];
  data.forEach((item, index) => {
    const { device_id, latitude, longitude, timestamp, battery_level, device_name, lte_pci, lte_rsrp, direction, speed } = item;
    // const color = 'rgba(' + counter_rgb + ',' + (255 - counter_rgb) + ',' + (255 - counter_rgb) + ',' + counter + ')'
    // const color = 'rgba(' + 255 + ',' + (0) + ',' + (0) + ',' + counter + ')'
    const color = item.resend === 1 ? 'black' : drawMarkerGradient(data.length, index);
    const marker = L.circleMarker([latitude, longitude], {
    color: color,
    radius: 5, // 마커 크기
    fillColor: color,
    fillOpacity: 1,
    deviceId: device_id,
    timestamp: timestamp,
    batteryLevel: battery_level,
    deviceName: device_name,
    resend: item.resend,
    border: '5px',
    })
    .bindPopup(`<b>Device ID:</b> ${device_id}<br>
                <b>Device Name:</b> ${device_name}<br>
                <b>Timestamp:</b> ${new Date(timestamp)}<br>
                <b>BatteryLevel:</b> ${battery_level}<br>
                <b>PCI:</b> ${lte_pci}<br>
                <b>RSRP:</b> ${lte_rsrp}<br>
                <b>Direction:</b> ${direction}<br>
                <b>Speed:</b> ${speed}<br>
                <b>Latitude:</b> ${latitude}<br>
                <b>Longitude:</b> ${longitude}<br>`);
    
    marker.on('click', () => {
      selectedRow.value = index; // 마커를 클릭하면 해당하는 행을 선택함

      const text = `${latitude}, ${longitude}`;
      navigator.clipboard.writeText(text)
      .then(() => {
        // console.log("클립보드 복사 완료:", text);
        showNotification(text + ' 복사 완료', 'info', 'top-center');
      })
      .catch(err => {
        console.error("클립보드 복사 실패:", err);
      });
    });
    
    markerGroup.addLayer(marker);
    latlngList.value.push(marker.getLatLng());
    newMarkers.push(marker);

    // counter += check;
    // counter_rgb += check_rgb;
  });
  allMarkers.value = newMarkers;
  pathMap.value?.invalidateSize(); // 지도 크기를 다시 계산
};

const showSelectedMarker = (marker, index) => {
  const latlngData = marker.getLatLng();
  const text = `${latlngData.lat}, ${latlngData.lng}`;
  navigator.clipboard.writeText(text)
  .then(() => {
    // console.log("클립보드 복사 완료:", text);
    showNotification(text + ' 복사 완료', 'info', 'top-center');
  })
  .catch(err => {
    console.error("클립보드 복사 실패:", err);
  });
  selectMarker(marker, index, true);
};

const selectMarker = (marker, index, animationOn = false) => {
  selectedRow.value = ((currentPage.value - 1) * itemsPerPage.value) + index; // 마커를 클릭하면 해당하는 행을 선택함
  if (animationOn) {
    pathMap.value.setView(marker.getLatLng());
    marker.openPopup();
  } else {
    if (index === 0) pathMap.value.fitBounds(latlngList.value);
  }
};

const setScroll = async (index) => {
  if (!markerCards.value || !cardContainer.value) return;

  const card = markerCards.value[0].$el || markerCards.value[0];
  const container = cardContainer.value;

  await nextTick(); // 🔹 DOM 업데이트 이후 실행

  const cardHeight = card.offsetHeight; // 카드의 높이
  const containerHeight = container.clientHeight; // 컨테이너의 높이
  const gap = 5; // 상위 컨테이너에서 설정한 gap (예시로 5px)

  // 📌 (1) 카드 순서에 맞게 위치를 계산
  const cardPosition = (index % itemsPerPage.value) * (cardHeight + gap); // 카드 높이와 gap을 합친 값으로 위치 계산

  // 📌 (2) 중앙에 맞추기 위해 수정된 스크롤 위치 계산
  let targetScroll = cardPosition - (containerHeight / 2) + (cardHeight / 2);

  // 📌 (3) 스크롤 범위 제한
  const totalHeight = (itemsPerPage.value * (cardHeight + gap)) - gap; // 전체 콘텐츠 높이 (gap 포함)
  const maxScroll = totalHeight - containerHeight; // 최대 스크롤 범위
  targetScroll = Math.max(0, Math.min(targetScroll, maxScroll)); // 범위 내에서 스크롤 조정

  // 📌 (4) 부드러운 스크롤 적용
  container.scrollTo({
    top: targetScroll,
    behavior: "smooth",
  });
};

watch(selectedRow, (newIndex) => {
  const showPage = parseInt(selectedRow.value / itemsPerPage.value) + 1;
  if (currentPage.value !== showPage) currentPage.value = showPage

  if (newIndex !== null) {
    setScroll(newIndex); // 🔹 선택된 행이 변경될 때 스크롤 조정
  }
});

let currentIndex = 0;
let replayInterval;
const startReplay = () => {
  if (currentIndex === 0) markerGroup.clearLayers();

  let marker = allMarkers.value[currentIndex];
  if (!marker) return;

  isStartedReplay.value = true;

  markerGroup.addLayer(marker); // 한 개씩 추가
  selectMarker(marker, currentIndex, selectedSpeed.value >= 0.5);

  replayInterval = setInterval(() => {
    currentIndex++;
    if (currentIndex >= allMarkers.value.length) {
      clearInterval(replayInterval);  // 모든 경로를 그리고나면 종료
      currentIndex = 0;
      isStartedReplay.value = false;
      if (selectedSpeed.value === '0') isCanNotReplay.value = true;
      return;
    }
    marker = allMarkers.value[currentIndex];
    markerGroup.addLayer(marker);
    selectMarker(marker, currentIndex, selectedSpeed.value >= 0.5);
  }, selectedSpeed.value * 1000); // 1초 간격으로 재생 (속도 조절 가능)
};

const stopReplay = () => {
  isStartedReplay.value = false;
  clearInterval(replayInterval);
  currentIndex = 0;
};

const handleMouseDown = (event) => {
  if (modal.value.contains(event.target)) {
    isDragging = true; // 모달 내부에서 클릭 시작
  }
};

const handleMouseUp = (event) => {
  if (!modal.value.contains(event.target) && !isDragging) {
    isPathModalOpen.value = false; // 모달 외부에서 클릭 떼면 닫기
  }
  isDragging = false; // 드래그 상태 초기화
};

// 🖼️ 신호 세기에 따른 이미지 경로 반환
const batteryImage = (batlevel) => {
  if (!batlevel) return new URL('../assets/images/battery3.svg', import.meta.url).href;
  if (batlevel >= 70) return new URL('../assets/images/battery1.svg', import.meta.url).href;
  if (batlevel >= 30) return new URL('../assets/images/battery2.svg', import.meta.url).href;
  return new URL('../assets/images/battery3.svg', import.meta.url).href;
};


const currentPage = ref(1);
const itemsPerPage = computed(() => { return (getIsMobile() ? 10 : 20) });
const showOncePage = computed(() => { return (getIsMobile() ? 5 : 5) });
// 페이지네이션된 데이터 계산
const totalPages = computed(() =>
  Math.ceil(filteredList.value.length / itemsPerPage.value)
);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return filteredList.value.slice(start, start + itemsPerPage.value);
});
const minPageRange = computed(() => {
  if (currentPage.value % showOncePage.value === 0) return currentPage.value - (showOncePage.value - 1);
  else return currentPage.value - ((currentPage.value % showOncePage.value) - 1);
});
const maxPageRange = computed(() => {
  let num = minPageRange.value + (showOncePage.value - 1);
  if (num > totalPages.value) num = totalPages.value
  return num;
});
const currentPageRange = computed(() => {
  const range = []
  for (let i = minPageRange.value; i <= maxPageRange.value; i++) {
    range.push(i)
  }
  return range;
});
// 페이지네이션 함수
const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--;
};
const prevPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  if (num < 1) currentPage.value = 1;
  else currentPage.value = ((num - 1) * showOncePage.value) + 1;
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++;
};
const nextPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  const check = ((num + 1) * showOncePage.value) + 1
  if (check > totalPages.value) currentPage.value = totalPages.value;
  else currentPage.value = check;
};

const filteredList = computed(() => {
  return allMarkers.value;
});

// 현재 보고있는 페이지를 전체 페이지수에 맞춰 자동으로 바꿔줌
watch(
  () => filteredList.value.length,
  () => {
    const newTotalPages = Math.ceil(filteredList.value.length / itemsPerPage.value);
    if (currentPage.value > newTotalPages) {
      currentPage.value = newTotalPages || 1; // 0일 때도 대비
    }
  }
);
</script>

<style>
.selected {
  background-color: rgba(76, 175, 80, 0.3); /* 기존보다 진한 강조 */
  border-left: 6px solid #4caf50; /* 더 굵은 강조선 */
  transform: scale(1.03); /* 살짝 확대 효과 */
  transition: background 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2); /* 그림자 추가 */
}
</style>